module.exports = __webpack_public_path__ + "static/img/footR1.6c755c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/footR1.png
// module id = jwez
// module chunks = 0